import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import mk from './locales/mk.json';
import en from './locales/en.json';

// D-05 — EN-shape drift detector.
// `typeof mk` is the canonical resources shape (D-04). Asserting `en` against it
// forces tsc -b to fail at build time if EN drifts (extra keys, missing keys,
// or mismatched value types). The const itself is unused at runtime; we keep
// the assignment purely so tsc validates the shape. The `eslint-disable` line
// silences the unused-vars lint inside the assertion.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _en: typeof mk = en;

void i18n.use(initReactI18next).init({
  // D-02: MK ships eagerly. EN is registered later by useLangSync via dynamic import.
  resources: {
    mk: { translation: mk },
  },
  lng: 'mk',
  fallbackLng: 'mk',
  defaultNS: 'translation',
  ns: ['translation'],
  interpolation: { escapeValue: false }, // React already escapes
  returnNull: false,
});

export default i18n;

// D-02: lazy EN loader. Plan 02-02's useLangSync calls this on the first MK→EN
// transition. Vite splits this dynamic import into its own chunk automatically
// (verifiable in dist/assets/ — a separate `en-*.js` chunk file is emitted).
let enLoaded = false;
export async function ensureEnLoaded(): Promise<void> {
  if (enLoaded) return;
  const mod = await import('./locales/en.json');
  i18n.addResourceBundle('en', 'translation', mod.default, true, true);
  enLoaded = true;
}

// Tree-shake guard — Plan 02-02's useLangSync will be the runtime consumer of
// ensureEnLoaded. Until that lands, Rollup would treat the function as dead code
// and eliminate it AND its dynamic `import('./locales/en.json')` chunk. Attaching
// the function as a property of the live i18n default export forces Rollup to
// keep it in the chunk graph, so the EN lazy chunk is emitted at build time.
// The cast is the minimum-surface way to extend i18next's exported instance.
(i18n as typeof i18n & { ensureEnLoaded: typeof ensureEnLoaded }).ensureEnLoaded = ensureEnLoaded;
